import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as Svg } from '../../assets/arrowUp.svg';

const ArrowUpIcon = (props: SvgIconProps) => {
  const {
    color,
    fontSize,
    htmlColor,
    shapeRendering,
    sx,
    titleAccess,
    viewBox,
  } = props;

  return (
    <SvgIcon
      color={color}
      fontSize={fontSize}
      htmlColor={htmlColor}
      shapeRendering={shapeRendering}
      sx={sx}
      titleAccess={titleAccess}
      viewBox={viewBox ?? '0 0 15 8'}
      component={Svg}
    />
  );
};

export default ArrowUpIcon;
